import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TeamOrgChartReducer } from '../reducers';

export const selectTeamOrgChartFeature = createFeatureSelector<TeamOrgChartReducer.TeamOrgChartState>(TeamOrgChartReducer.featureName);

export const selectTeamOrgChart = createSelector(selectTeamOrgChartFeature, (state: TeamOrgChartReducer.TeamOrgChartState) => state.item);
